import React from 'react'
import { renderRoutes } from 'react-router-config'
import { Redirect } from 'react-router-dom'

import LazyImport from 'src/HOC/LazyImport'
import withAuthentication from 'src/HOC/withAuthentication'
import withOutAuthentication from 'src/HOC/withOutAuthentication'
import AuthLayout from 'src/components/App/components/AuthLayout'
import NotFound from 'src/scenes/NotFound'

export const rootAdminRoutes = [
  {
    path: '/auth',
    component: withOutAuthentication(AuthLayout),
    routes: [
      {
        path: '/auth/login',
        component: LazyImport(() =>
          import('src/scenes/Auth/scenes/Login' /* webpackChunkName: "Login" */)
        )
      },
      {
        path: '/auth/set-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/SetPassword' /* webpackChunkName: "Set Password" */
          )
        )
      },
      {
        path: '/auth/forgot-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/ForgotPassword' /* webpackChunkName: "Forgot Password" */
          )
        )
      },
      {
        path: '/auth/reset-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/ResetPassword' /* webpackChunkName: "Reset Password" */
          )
        )
      },
      {
        path: '/auth',
        component: () => <Redirect to="/auth/login" />
      }
    ]
  },
  {
    path: '/',
    component: withAuthentication(
      LazyImport(() =>
        import(
          'src/components/App/components/AdminLayout' /* webpackChunkName: "AdminLayout" */
        )
      )
    ),
    routes: [
      {
        exact: true,
        path: '/',
        component: () => <Redirect to="/admin" />
      },
      {
        path: '/admin',
        component: ({ route }) => renderRoutes(route.routes),
        routes: [
          {
            path: '/admin/:uuid',
            component: LazyImport(() =>
              import(
                'src/scenes/Companies/scenes/Company' /* webpackChunkName: "Company" */
              )
            ),
            routes: [
              {
                path: '/admin/:uuid/profile',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/Profile' /* webpackChunkName: "CompanyProfile" */
                  )
                )
              },
              {
                path: '/admin/:uuid/licenses',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/Licenses' /* webpackChunkName: "CompanyLicenses" */
                  )
                )
              },
              {
                path: '/admin/:uuid/org-chart',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/OrgChart' /* webpackChunkName: "CompanyOrgChart" */
                  )
                )
              },
              {
                exact: true,
                path: '/admin/:companyUuid/user-roles',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/UserRoles/scenes/UserRoles' /* webpackChunkName: "CompanyUserRoles" */
                  )
                )
              },
              {
                path: '/admin/:companyUuid/user-roles/:roleUuid/edit',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/UserRoles/scenes/EditPage' /* webpackChunkName: "CompanyUserRolesEdit" */
                  )
                )
              },
              {
                path: '/admin/:uuid/users',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/Users' /* webpackChunkName: "CompanyUsers" */
                  )
                )
              },
              {
                path: '/admin/:uuid/company-settings',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/CompanySettings' /* webpackChunkName: "CompanySettings" */
                  )
                )
              },
              {
                path: '/admin/:uuid/integration',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/IntegrationSettings' /* webpackChunkName: "IntegrationSettings" */
                  )
                )
              },
              {
                path: '/admin/:uuid/payer-management',
                component: LazyImport(() =>
                  import(
                    'src/scenes/Companies/scenes/Company/scenes/PayerManagement' /* webpackChunkName: "PayerManagement" */
                  )
                )
              },
              {
                path: '/admin/:uuid',
                component: ({
                  match: {
                    params: { uuid }
                  }
                }) => <Redirect to={`/admin/${uuid}/profile`} />
              }
            ]
          },
          {
            path: '/admin',
            component: LazyImport(() =>
              import(
                'src/scenes/Companies/scenes/CompaniesSearch' /* webpackChunkName: "CompaniesSearch" */
              )
            )
          }
        ]
      },
      {
        path: '/ribbon-management',
        component: LazyImport(() =>
          import(
            'src/scenes/Companies/scenes/RibbonManagement' /* webpackChunkName: "RibbonManagement" */
          )
        )
      },
      {
        path: '/medical-device-ordering',
        component: LazyImport(() =>
          import(
            'src/scenes/Companies/scenes/MedicalDeviceOrdering' /* webpackChunkName: "MedicalDeviceOrdering" */
          )
        )
      },
      {
        path: '/search',
        component: LazyImport(() =>
          import(
            'src/scenes/Companies/scenes/UserSearch' /* webpackChunkName: "UserSearch" */
          )
        )
      },
      {
        path: '/admin-sms-log',
        component: LazyImport(() =>
          import(
            'src/scenes/Reports/SMSLog' /* webpackChunkName: "AdminSMSLog" */
          )
        )
      }
    ]
  },
  {
    path: '/not-found',
    component: NotFound
  },
  {
    path: '*',
    component: () => <Redirect to="/not-found" />
  }
]
